exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TableReport .Loading {\n  position: initial;\n}\n\n.TableReport .ReportDescription {\n  padding-bottom: 25px;\n}\n\n.TableReport .unable-to-fetch-data {\n  font-size: 12px;\n  text-align: center;\n}\n", ""]);

// exports
